import React from "react";
import DataTable from "react-data-table-component";
import "./index.css";

const columns = [
  {
    name: "Support ID",
    selector: (row) => row.SupportId,
    // sortable: true,
    grow: 1,
  },
  {
    name: "Trip ID",
    selector: (row) => row.tripId,
    // sortable: true,
    grow: 1,
  },

  {
    name: "Status",
    cell: (row) => (
      <span
        style={{
          backgroundColor: row.status === "open" ? "#FFD6D6" : "#D6FFD6",
          padding: "4px 8px",
          borderRadius: "5px",
          color: row.status === "open" ? "#FF5C5C" : "#2ECC71",
        }}
      >
        {row.status}
      </span>
    ),
    grow: 1,
    // sortable: true,
  },
  {
    name: "Message",
    selector: (row) => row.remarks,
    wrap: true,
    grow: 2,
  },
];

// const customStyles = {
//   tableWrapper: {
//     style: {
//         borderRadius: "16px",
//         overflow: "hidden",
//     },
//   },
//   table: {
//     style: {
//       borderCollapse: "separate",
//       borderSpacing: "0",
//     },
//   },
//   headRow: {
//     style: {
//       backgroundColor: "#EAF6FD",
//       color: "#13487D",
//       fontWeight: "bold",
//       fontSize: "14px",
//       borderTop: "none", // remove top border
//       borderBottom: "none", // remove bottom border
//     },
//   },
//   rows: {
//     style: {
//       borderBottom: "1px solid #E0E0E0", // only row separators
//       minHeight: "60px",
//       fontSize: "14px",
//     },
//   },
//   pagination: {
//     style: {
//       borderTop: "none", // removes the line above pagination
//       paddingTop: "10px",
//     },
//   },
// };
const customStyles = {
  tableWrapper: {
    style: {
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
      overflow: "hidden",
    },
  },
  headRow: {
    style: {
      backgroundColor: "rgba(76, 120, 137, 0.1)",
      color: "rgba(79, 123, 140, 1)",
      fontWeight: "500",
      fontSize: "18px",
      borderTop: "none",
      borderBottom: "none",
    },
  },
  pagination: {
    style: {
      borderTop: "none",
    },
  },
  rows: {
    style: {
      borderBottom: "1px solid #E0E0E0",
    },
  },
};

const PaginatedTable = ({
  data,
  // page,
  setPage,
  limit,
  setLimit,
  totalRows,
}) => {
  return (
    <div className="data-table-wrapper">
      <DataTable
        columns={columns}
        data={data}
        customStyles={customStyles}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(newPerPage, page) => {
          setLimit(newPerPage);
          setPage(page);
        }}
      />
    </div>
  );
};

export default PaginatedTable;
